import { Routes, Route } from "react-router-dom";
import DeliveryConditions from "./DeliveryConditions";
import DeliveryConditionCreateEdit from "./DeliveryConditionCreateEdit";

const index = () => {
	return (
		<Routes>
			<Route index element={<DeliveryConditions />} />
			<Route path='/create' element={<DeliveryConditionCreateEdit />} />
			<Route path='/:id/edit' element={<DeliveryConditionCreateEdit />} />
		</Routes>
	);
};

export default index;
